import { render, staticRenderFns } from "./redirect-weassist.vue?vue&type=template&id=fb6ac390&scoped=true"
import script from "./redirect-weassist.vue?vue&type=script&lang=ts"
export * from "./redirect-weassist.vue?vue&type=script&lang=ts"
import style0 from "./redirect-weassist.vue?vue&type=style&index=0&id=fb6ac390&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6ac390",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb6ac390')) {
      api.createRecord('fb6ac390', component.options)
    } else {
      api.reload('fb6ac390', component.options)
    }
    module.hot.accept("./redirect-weassist.vue?vue&type=template&id=fb6ac390&scoped=true", function () {
      api.rerender('fb6ac390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/redirect-weassist.vue"
export default component.exports